<template>
  <!-- 预约顾问 -->
  <div class="appointment main-container">
    <div class="top-box">
      预约顾问：客户提供手机号留资的H5页面，支持配置在多个功能入口，例如单款产品详情页；网店工具栏；其他通用预约入口等等。同时您可以自定义预约顾问留资页面及字段，查看相关预约顾问订单和相关跟进结果。
    </div>
    <div class="page-content">
      <phone :config="config" :list="formList"></phone>
      <div class="right-box">
        <div class="title-box">
          <div class="title2">顶部banner</div>
          <div class="title-info">上传图片最大不超过500kb，仅限jpg/jpeg/gif/bmp/png格式，建议Banner图片尺寸为750*360</div>
        </div>
        <upload v-model="config.banner" width="208" height="100"></upload>

        <div class="title-box">
          <div class="title2">预约字段</div>
        </div>
        <div class="table-box">
          <loading :isShow="listLoading" />
          <Table :columns="columns" :data="list" @on-selection-change="onSelect">
            <template slot-scope="{ row,index }" slot="key1">
              <ul class="show-btn" :class="{'disabled':row.isMustChecked==1}">
                <li :class="{'active':row.isRequired==1}" @click="requiredChange(index,1)">是</li>
                <li :class="{'active':row.isRequired==0}" @click="requiredChange(index,0)">否</li>
              </ul>
            </template>
          </Table>
        </div>

        <div class="title-box">
          <div class="title2">
            分享标题
            <Poptip placement="bottom-start" popper-class="img-poptip" trigger="hover">
              <i class="iconfont iconwenhao1"></i>
              <img slot="content" src="@static/images/appointment/appointment02.png" alt="">
            </Poptip>
          </div>
          
        </div>
        <Input v-model="config.shareTitle" placeholder="请输入"/>

        <div class="title-box">
          <div class="title2">分享描述
            <Poptip placement="bottom-start" popper-class="img-poptip" trigger="hover">
              <i class="iconfont iconwenhao1"></i>
              <img slot="content" src="@static/images/appointment/appointment03.png" alt="">
            </Poptip>
          </div>
        </div>
        <Input v-model="config.shareDesc" placeholder="请输入" type="textarea"/>

        <div class="title-box">
          <div class="title2">分享图片
            <Poptip placement="bottom-start" popper-class="img-poptip" trigger="hover">
              <i class="iconfont iconwenhao1"></i>
              <img slot="content" src="@static/images/appointment/appointment01.png" alt="">
            </Poptip>
          </div>
          <div class="title-info">上传图片最大不超过500kb，仅限jpg/jpeg/gif/bmp/png格式，建议分享图片图片尺寸为100*100</div>
        </div>
        <upload v-model="config.shareImg" width="100" height="100"></upload>
      </div>
    </div>

    <div class="dom-height"></div>
    <div class="btn-list">
      <div class="btn-box">
        <Button type="primary" ghost class="btn" @click="close">取消</Button>
        <Button type="primary" class="btn" @click="save">确认生成</Button>
      </div>
    </div>
  </div>
</template>

<script>
import phone from "./components/phone";
import upload from "./components/upload";
import {pageTool} from "@/api/mixins";
import {config} from "./formSet.config.js";
export default {
  mixins:[pageTool, config],
  components: {
    phone,
    upload,
  },
  props: {},
  data() {
    return {
      config:{},
      list:[],
      formList:[],
    };
  },
  watch: {},
  computed: {},
  created() {},
  mounted() {
    this.queryConfig();
    this.getList();
  },
  methods: {
    close(){
      const fullPath = this.$route.fullPath;
      this.$router.push({
        path: "/orderManage/appointment",
      })
      window.setTimeout(()=>{
        window.parent.postMessage({
          removePageTag: fullPath,
          appMessage: true,
        }, "*");
      },100);
    },
    save(){
      const params = JSON.parse(JSON.stringify(this.config));
      params.filedConfigs = this.list;
      console.log(params.filedConfigs)
      this.$http({
        url: "/buz/subscribe/saveSubscribeConfig",
        type: "POST",
        data: params,
        apiPermissionCode:'systemSet_20_1'
      }).then((res)=>{
        this.$notice.success("操作成功");
        this.close();
      })
    },
    getList(){
      this.$http({
        url: "/buz/subscribe/queryFiledList",
        type: "PUT",
        data: {}
      }).then((res) => {
        res.data.forEach(item=>{
          if(item.isMustChecked==1){
            item._disabled = true;
            item._checked = true;
          }else if(item.isChecked==1){
            item._checked = true;
          }
        })
        this.list = res.data;
        this.formList = this.list.filter(item=>{
          return item.isChecked==1
        })
      })
    },
    queryConfig(){
      this.$http({
        url: "/buz/subscribe/queryConfig",
        type: "PUT",
        data: {
          
        }
      }).then((res) => {
        this.config = res.data;
      })
    },
    // 修改必填
    requiredChange(i,value){
      if(this.list[i].isMustChecked==1){
        return;
      }
      const checkKeys = this.formList.map(item=>{
        return item.filed;
      })
      this.$set(this.list[i],'isRequired',value);
      // this.list.forEach(item=>{
      //   if(checkKeys.includes(item.filed)){
      //     this.$set(item,'_checked',true)
      //   }
      // })
    },
    // 列表选择
    onSelect(selectArr){
      
      this.formList = selectArr;
      const keys = this.formList.map(item=>{
        return item.filed;
      })
      console.log(selectArr,keys)
      this.list.forEach(item=>{
        if(keys.includes(item.filed)){
          item.isChecked = 1;
          item._checked = true;
        }else{
          item.isChecked = 0;
          item._checked = false;
        }
      })
    }
  },

};
</script>
<style lang="scss" scoped>
@import "./formSet.scss";
</style>
